<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSessionStore } from '@/stores/session'
import LoginView from '@/views/LoginView.vue'
import AppShell from '@/components/AppShell.vue'
import ClientBriefView from '@/views/ClientBriefView.vue'
import ClientDashboardView from '@/views/ClientDashboardView.vue'
import TeamWorkbenchView from '@/views/TeamWorkbenchView.vue'
import MembersView from '@/views/MembersView.vue'
import ModelConfigView from '@/views/ModelConfigView.vue'
import AgentSkillsView from '@/views/AgentSkillsView.vue'
import CollaborationView from '@/views/CollaborationView.vue'
import ManualTasksView from '@/views/ManualTasksView.vue'
import AdminWorkflowView from '@/views/AdminWorkflowView.vue'
import PartnerServiceView from '@/views/PartnerServiceView.vue'
import InternalPartnerRequestsView from '@/views/InternalPartnerRequestsView.vue'

const session = useSessionStore(); const { locale } = useI18n(); const view = ref('work')
const isPartner = computed(() => session.user?.role === 'client' && session.user?.account_type === 'partner')
const selectedBriefId = computed(() => view.value.startsWith('brief:') ? Number(view.value.slice(6)) : undefined)
onMounted(async () => { await session.restore(); locale.value = session.locale; view.value = session.user?.role === 'client' ? 'home' : 'work' })
watch(() => session.locale, value => { locale.value = value })
watch(() => session.user?.role, role => { if (role) view.value = role === 'client' ? 'home' : 'work' })
</script>

<template>
  <LoginView v-if="!session.authenticated" />
  <AppShell v-else :view="view" @change-view="view = $event">
    <ClientDashboardView v-if="session.user?.role === 'client' && view === 'home'" @open-brief="view = $event ? `brief:${$event}` : 'briefs'" />
    <PartnerServiceView v-else-if="isPartner && view === 'briefs'" @open-brief="view = `brief:${$event}`" />
    <ClientBriefView v-else-if="session.user?.role === 'client' && (view.startsWith('brief:') || view === 'history' || (!isPartner && view === 'briefs'))" :brief-id="selectedBriefId" :start-new="view === 'briefs'" :show-history="view === 'history'" @open-brief="view = `brief:${$event}`" @deleted="view = 'home'" />
    <TeamWorkbenchView v-else-if="view === 'work'" />
    <MembersView v-else-if="view === 'members'" />
    <ModelConfigView v-else-if="view === 'model'" />
    <AgentSkillsView v-else-if="view === 'skills'" />
    <CollaborationView v-else-if="view === 'collaboration'" />
    <ManualTasksView v-else-if="view === 'tasks'" />
    <AdminWorkflowView v-else-if="view === 'admin-workflow'" />
    <InternalPartnerRequestsView v-else-if="view === 'partner-requests'" />
  </AppShell>
</template>
